<!--
 * @Author: aiial 2260457739@qq.com
 * @Date: 2022-08-23 08:25:20
 * @LastEditors: aiial 2260457739@qq.com
 * @LastEditTime: 2022-08-25 09:10:05
 * @FilePath: \yifanshangadmin\src\utils\ty.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
var language_url = 'tinymce/langs/zh_CN.js'
var language = 'zh_CN'
var oxide = '/tinymce/skins/ui/oxide'
var dark = '/tinymce/skins/ui/oxide-dark'
var content_dark = '/tinymce/skins/content/dark/content.css'
var content_default = '/tinymce/skins/content/default/content.css'
var plugins = ['link lists image code table  wordcount']
var toolbar = [
  'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
  'hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table  fontsizeselect  fontselect emoticons forecolor backcolor fullscreen',
]

var apiurl ='https://xcx.hzzxbiologic.cn'

 //var apiurl = 'http://192.168.2.192:8036'
export default {
  language_url,
  language,
  oxide,
  dark,
  content_dark,
  content_default,
  plugins,
  toolbar,
  apiurl,
}
</script>
